import { render } from "./mensajefinal.vue?vue&type=template&id=60a6ce81&scoped=true"
import script from "./mensajefinal.vue?vue&type=script&lang=js"
export * from "./mensajefinal.vue?vue&type=script&lang=js"

import "./mensajefinal.vue?vue&type=style&index=0&id=60a6ce81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a6ce81"]])

export default __exports__